import { Map } from 'immutable';

export default Map({
  data: null,
});
